export function getDashboardPathSegments(pathname: string) {
    const segments = pathname.split('/').filter(Boolean);
    const dashboardIndex = segments.findIndex(
        (segment) => segment.toLowerCase() === 'dashboard',
    );
    const child =
        dashboardIndex >= 0 ? segments[dashboardIndex + 1] : undefined;
    const grandchild =
        dashboardIndex >= 0 ? segments[dashboardIndex + 2] : undefined;

    return {
        child,
        grandchild,
        mappingKey: child
            ? grandchild
                ? `${child}-${grandchild}`
                : `${child}-undefined`
            : undefined,
    };
}

export function formatDashboardPeriodLabel(segment?: string): string {
    if (!segment) {
        return 'Report';
    }

    return segment.charAt(0).toUpperCase() + segment.slice(1);
}

export function getUserReservationReportFileName(urlRef?: string): string {
    if (!urlRef) {
        return 'Report';
    }

    if (urlRef.includes('scheduled')) {
        return 'Your Scheduled - Report';
    }
    if (urlRef.includes('completed')) {
        return 'Your Completed Reservations - Report';
    }
    if (urlRef.includes('approved')) {
        return 'Your Upcoming Reservations - Report';
    }
    if (urlRef.includes('pending')) {
        return 'Your Pending Reservations - Report';
    }

    return 'Report';
}
